export default __webpack_public_path__ + "static/avatar-27089b4274cfc378526fc19298d954a7.jpeg";